var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthenticator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.5293 2.8733L6.71403 5.60579C5.22202 6.13637 4 7.78117 4 9.28006V20.0243C4 21.0987 4.75311 22.518 5.67673 23.1547L13.492 28.6065C14.8703 29.5748 17.1297 29.5748 18.508 28.6065L26.3233 23.1547C27.2469 22.5048 28 21.0987 28 20.0243V9.28006C28 7.79444 26.778 6.13637 25.286 5.61906L17.4707 2.88657C16.675 2.59475 15.3393 2.59475 14.5293 2.8733Z",
    fill: "#4DAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 14.8283C18.6666 13.2671 17.4719 12 15.9999 12C14.5279 12 13.3333 13.2671 13.3333 14.8283C13.3333 16.0954 14.1226 17.1475 15.1999 17.5095V20.4848C15.1999 20.9487 15.5626 21.3333 15.9999 21.3333C16.4373 21.3333 16.7999 20.9487 16.7999 20.4848V17.5095C17.8773 17.1475 18.6666 16.0954 18.6666 14.8283Z",
    fill: "#4DAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticator);
export default __webpack_public_path__ + "static/media/authenticator.4433a56878b12973ebdbbdf00283e088.svg";
export { ForwardRef as ReactComponent };